import React from 'react';
import { ProgressView, SatCoreRegister, StudentHelperService } from 'sat-core';

// import iconCommentActiveYellow from '../img/icon-comment-active-yellow.svg';

// const ProgressViewSummaryLegend = ({ data }) => {
//   return StudentHelperService.getProgressSummaryLegend({ data });
// };

const ProgressViewOverride = (props) => {
  const progressViewOverrideOptions = StudentHelperService.getProgressViewOverrideOptions({
    progressWidget: false, // set via `allowedStudentProgressWidgets` array in satelliteLayout JSON config instead
    summaryWidget: false, // ^^
    trophiesWidget: false, // ^^
    weeklyPerformanceWidget: false // ^^
  });
  // TODO remove
  // const progressViewOverrideOptions = StudentHelperService.getProgressViewOverrideOptions({
  //   progressWidget: true,
  //   summaryWidget: false,
  //   trophiesWidget: true,
  //   weeklyPerformanceWidget: false
  // });
  return (
    <ProgressView {...props} {...progressViewOverrideOptions}
      // summaryLegend={ProgressViewSummaryLegend}
      feedbackIconActiveImg={undefined}
      leftCol={true} />
  );
};

SatCoreRegister('ProgressView', ProgressViewOverride);
